import fetchIntercept from 'fetch-intercept';
import AuthValidationService from './services/AuthValidationService';

export default function HttpInterceptor(store) {
 
    fetchIntercept.register({
        request: function (url, config) {
            // NO TOCAR endpoints de admin - HttpService ya maneja el token correcto
            if (url.includes('admin/')) {
                return [url, config];
            }
            
            // Solo para endpoints que NO son admin, inyectar user-token si es necesario
            if (config && config.headers && !config.headers.Authorization && !config.headers.authorization) {
                const userToken = localStorage.getItem('user-token');
                if (userToken) {
                    config.headers.Authorization = `Bearer ${userToken}`;
                }
            }
            
            return [url, config];
        },

        requestError: function (error) {
            // Called when an error occured during another 'request' interceptor call
            return Promise.reject(error);
        },

        response: function (response) {
            // Manejar respuestas de autenticación
            if (!response.url.includes('api.forcemanager.com') && response.status === 401) {
                
                // Si no es una llamada a refresh-token, intentar refrescar
                if (!response.url.includes('refresh-token')) {
                    // El refresh se manejará automáticamente en el próximo request
                }
                
                // Limpiar todos los tokens y redirigir al login
                AuthValidationService.clearTokens();
                
                // Evitar redirección infinita si ya estamos en login
                if (!window.location.pathname.includes('/login')) {
                    AuthValidationService.redirectToLogin();
                }
            }
            
            // Manejar otros errores de servidor
            if (response.status >= 500) {
                console.error('Error del servidor:', response.status, response.statusText);
            }
            
            return response;
        },

        responseError: function (error) {
            // Handle fetch errors (network, timeout, etc.)
            console.error('Response error:', error);
            
            // Si es un error de red, podemos manejarlo de forma diferente
            if (error.name === 'TypeError' && error.message.includes('fetch')) {
                console.error('Error de conexión de red');
            }
            
            return Promise.reject(error);
        }
    })
    
}